dmx.Component('local-manager', {

    initialData: {
        data: {}
    },

    attributes: {},

    methods: {
        set: function(key, value) {
            var val = JSON.stringify(value);
            if (val != null) {
                window.localStorage.setItem('dmxState-' + key, val);
            } else {
                window.localStorage.removeItem('dmxState-' + key);
            }
            this.getData();
        },

        remove: function(key) {
            window.localStorage.removeItem('dmxState-' + key);
            this.getData();
        },

        removeAll: function() {
            Object.keys(window.localStorage).forEach(function(key) {
                if (key.startsWith('dmxState-')) {
                    window.localStorage.removeItem(key);
                }
            });
            this.getData();
        }
    },

    render: function(node) {
        this.getData();
    },

    getData: function() {
        this.set('data', Object.keys(window.localStorage).reduce(function(data, key) {
            if (key.startsWith('dmxState-')) {
                try {
                    data[key.substr(9)] = JSON.parse(window.localStorage.getItem(key));
                } catch (e) {
                    console.warn('Error parsing JSON: ' + window.localStorage.getItem(key));
                }
            }

            return data;
        }, {}));
    }

});
